interface EventsCardProps {
  readonly eventsThisWeek: number;
}

export function EventsCard({ eventsThisWeek }: EventsCardProps) {
  return (
    <div className="p-5 bg-surface border border-border rounded-xl">
      <div className="text-sm font-semibold text-ink mb-1">Événements</div>
      <div className="text-3xl font-black text-accent">{eventsThisWeek}</div>
      <div className="text-xs text-ink-muted mt-1 uppercase tracking-wide">
        Cette semaine
      </div>
    </div>
  );
}
